var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxlPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.454 11.6147L16.411 8.65773L6.86 3.28973C6.227 2.94773 5.634 2.89973 5.114 3.27373L13.454 11.6147ZM16.915 15.0767L19.989 13.3477C20.589 13.0117 20.918 12.5357 20.918 12.0077C20.918 11.4807 20.589 11.0037 19.99 10.6677L17.207 9.10473L14.074 12.2367L16.915 15.0767ZM4.6 4.00073C4.536 4.19773 4.5 4.41773 4.5 4.65873V19.3637C4.5 19.7447 4.584 20.0727 4.736 20.3337L12.833 12.2357L4.6 4.00073ZM13.454 12.8557L5.402 20.9087C5.556 20.9677 5.722 20.9987 5.897 20.9987C6.209 20.9987 6.534 20.9067 6.865 20.7227L16.12 15.5257L13.454 12.8557Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxlPlay);
export default __webpack_public_path__ + "static/media/bxl_play.e448e5048a335a427e915228c2495c07.svg";
export { ForwardRef as ReactComponent };